import request from '@/api/request'

const createInvoice = function (data) {
  return request({
    url: '/users/invoices',
    method: 'post',
    data,
    timeout: 2 * 60 * 1000
  })
}

const getInvoices = function () {
  return request({
    url: '/users/invoices',
    method: 'get'
  })
}

export default {
  createInvoice,
  getInvoices
}
